import styled from '@emotion/styled';
import { Button } from '@mui/base';

const AddInnerButton = styled(Button)`
  display: flex;
  padding: 8px 12px 8px 8px;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  border: 1px solid var(--dk-line, #e7e9ec);
  background: var(--dk-bg, #fff);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  color: var(--dk-text, #000000);

  :disabled {
    opacity: 0.5;
  }
`;

/** 추천 칩 목록 끝에 붙는 더보기/접기 텍스트 버튼 (칩과 높이 동일, 테두리 없음) */
const ToggleMoreButton = styled(Button)`
  display: flex;
  padding: 8px 4px;
  align-items: center;
  border: none;
  background: transparent;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--dk-text-secondary, #6b7280);
  text-decoration: underline;
  cursor: pointer;

  :hover {
    color: var(--dk-text, #000000);
  }
`;

export { AddInnerButton, ToggleMoreButton };
